import { PackedOnEnum } from 'api';

export const formatPackedOn = (packedOn: PackedOnEnum): string => {
  switch (packedOn) {
    case PackedOnEnum.wooden_pallets:
      return 'Wooden Pallets';
    case PackedOnEnum.no_pallets:
      return 'No pallets';
    default:
      return '';
  }
};
